module.exports = __webpack_public_path__ + "img/V94.46e3e390.jpg";